export const initialState = (inputResponse: any, isEdit = false) => {
  const splitList = (raw: any, fallback: string[]) => {
    if (Array.isArray(raw)) {
      return raw.map(String).filter(Boolean);
    }
    if (typeof raw === "string" && raw.trim()) {
      return raw.split(",").map((s) => s.trim()).filter(Boolean);
    }
    return fallback;
  };

  return {
    emp_type: { value: inputResponse.emp_type ?? "", error: "" },
    department: {
      value: inputResponse.department ?? "",
      id: inputResponse.departmentId || inputResponse.department_id || "",
      error: "",
    },
    designation: { value: inputResponse.designation ?? "", id: "", error: "" },
    joining: { value: inputResponse.joining ?? "", error: "" },
    dor: { value: inputResponse.dor ?? "", error: "" },
    // role_id: {
    //   value: inputResponse.role_name ?? "",
    //   id: inputResponse.role_id ?? "",
    //   error: "",
    // },
    // team_id: {
    //   value: inputResponse.team_name ?? [],
    //   id: inputResponse.team_id ?? [],
    //   error: "",
    // },
    // team_id:JSON.parse(inputResponse?.team_id || '{}'),
    team_id: inputResponse.team_id ?? "",
    working_days: {
      value: splitList(inputResponse.working_days, [
        "tuesday",
        "wednesday",
        "thursday",
        "Friday",
        "saturday",
        "sunday",
      ]),
      error: "",
    },
    working_shift: {
      value: splitList(inputResponse.working_shift, ["day"]),
      error: "",
    },
    id: { value: inputResponse._id ?? "", error: "" },
    hierarchyId: {
      value: inputResponse.hierarchyName ?? "",
      id: inputResponse.hierarchyId ?? "",
      hierarchyLevel: inputResponse.hierarchyLevel ?? "",
      error: "",
    },
    teamRoleId: {
      id: inputResponse.teamRoleId || "",
      hierarchyLevel: inputResponse.hierarchyLevel ?? "",
      // error: "",
    },
    teamRoleName: {
      value: inputResponse.teamRoleName ?? "",
    },
    reportingManagerId: {
      id: inputResponse.reportingManagerId ?? "",
    },
    reportingManagerName: {
      value: inputResponse.reportingManagerName ?? "",
    },
    isOrganization: {
      value:
        inputResponse.isOrganization === 1 || inputResponse.isOrganization === "1"
          ? 1
          : 0,
    },
  };
};

export const handleValidation = (rawInput: any) => {
  // if (rawInput.organizationId.value === "") {
  //   rawInput.organizationId.error = "Please enter a valid organization ID";
  // }
  // if (rawInput.companyname.value === "") {
  //   rawInput.companyname.error = "Please enter a valid company name";
  // }
  // if (rawInput.brandname.value === "") {
  //   rawInput.brandname.error = "Please enter a valid brand name";
  // }
  // if (rawInput.country_id.value === "") {
  //   rawInput.country_id.error = "Please enter a valid country ID";
  // }
  if(rawInput.joining.value === ""){
    rawInput.joining.error = "Please select a joining date";
  }
  if(rawInput.emp_type.value === ""){
    rawInput.emp_type.error = "Please select employee type";
  }
  // if(rawInput.team_id.value === ""){
  //   rawInput.team_id.error = "Please select team";
  // }
  // if(rawInput.role_id.value === ""){
  //   rawInput.role_id.error = "Please select role";
  // }
  // if(rawInput.reporting_manager.value === ""){
  //   rawInput.reporting_manager.error = "Please select reporting manager";
  // }
  // if(rawInput.department.value === ""){
  //   rawInput.department.error = "Please select department";
  // }
  // if(rawInput.designation.value === ""){
  //   rawInput.designation.error = "Please select designation";
  // }
  return rawInput;
};

export const validateInput = (name: string, value: string) => {
  if (name === "organizationId") {
    if (!/^[a-zA-Z0-9]+$/.test(value) || value.length > 10) {
      return false;
    }
  }
  if (name === "companyname" || name === "brandname") {
    if (!/^[a-zA-Z0-9\s]+$/.test(value) || value.length > 30) {
      return false;
    }
  }
  if (name === "country_id" || name === "state_id") {
    if (!/^[a-zA-Z]+$/.test(value) || value.length > 2) {
      return false;
    }
  }
  if (name === "currency" || name === "country_code" || name === "time_zone") {
    if (!/^[a-zA-Z]+$/.test(value) || value.length > 3) {
      return false;
    }
  }
  if (name === "city") {
    if (!/^[a-zA-Z\s]+$/.test(value) || value.length > 30) {
      return false;
    }
  }
  if (name === "address1" || name === "address2") {
    if (!/^[a-zA-Z0-9\s.,-]+$/.test(value) || value.length > 100) {
      return false;
    }
  }
  if (name === "zipcode") {
    if (!/^[0-9]+$/.test(value) || value.length > 6) {
      return false;
    }
  }

  return true;
};

export const getFinalBodyStructure = (inputBody: any) => {
  let finalBody = {};
  for (const key in inputBody) {
    finalBody = {
      ...finalBody,
      [key]: ["role_id", "team_id", "reporting_manager"].includes(key)
        ? inputBody[key].id || "NA"
        : inputBody[key].value,
    };
  }
  const newObj: any = { ...finalBody };

  // newObj.organizationId = userId;

  // ["updatedAt", "__v", "createdAt"].forEach((key: any) => delete newObj[key]);

  newObj.working_days = newObj.working_days.join(",");
  newObj.working_shift = newObj.working_shift.join(",");

  return newObj;
};
